import { message } from 'antd';
import ERR_MSG from 'utils/errorMessage';

const filterApiErr = (err: any) => {
  if (err.response) {
    const status = err.response.status;
    // Network Error
    if (status === 0) {
      // TODO: logging?
      message.error(`${ERR_MSG.CANNOT_SERVE} ${ERR_MSG.NETWORK}`);
      return null;
    }

    // Not Found
    if (status === 404) {
      // TODO: logging?
      message.error(`${ERR_MSG.NOT_FOUND} ${ERR_MSG.BAD_INPUT}`);
      return null;
    }

    // Specific Error: (3xx ~ 5xx) and !(404)
    return err;
  }

  if (err.request) {
    // Make Request but No Response
    // TODO: logging?
    message.error(`${ERR_MSG.CANNOT_SERVE} ${ERR_MSG.RETRY}`);
  } else {
    // Cannot Request
    // TODO: logging?
    message.error(`${ERR_MSG.CANNOT_SERVE} ${ERR_MSG.REPORT}`);
  }

  return null;
};

export default filterApiErr;
